import * as React from "react";
import { Context } from "./_context";
export const SubtlePushIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m15.53 7.47.052.056a.75.75 0 0 1-.052 1.004l-4.5 4.5-1.06-1.06L13.94 8 9.97 4.03l1.06-1.06 4.5 4.5Z", fill: "currentColor" }));
  return iconset[size];
};
SubtlePushIcon.iconId = "Hwv9dE";
